import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CheckIcon, CircleDashedIcon } from 'lucide-react';
import { FilterChip } from '../components/FilterChip';
import { MetricRow } from '../components/MetricRow';
import { PageHeader } from '../components/PageHeader';
import { Card, SectionTitle } from '../components/ui/Card';
import { strengthMilestones } from '../data/insights';
import { metricsForSport, sports } from '../data/sportMetrics';
import { useLocale } from '../contexts/LocaleContext';
import { useMetrics } from '../contexts/MetricsContext';
import type { SportId } from '../types';
export function SportMetrics() {
  const {
    sport: param
  } = useParams();
  const {
    t,
    tl
  } = useLocale();
  const navigate = useNavigate();
  const metrics = useMetrics();
  const sport = (sports.includes(param as SportId) ? param : 'running') as SportId;
  const list = metricsForSport(sport);
  return <div className="px-2 pb-2" data-id="element-3622" data-mp="3u6y92y7w8jbi">
      <PageHeader title={t(`category.${sport}`)} subtitle={t('metrics.sports.subtitle')} showBack data-id="element-3623" data-mp="3u5wlju9oy4cw" />

      <ul className="bee-rail -mx-2 flex gap-1 overflow-x-auto px-2 pb-1" role="tablist" data-id="element-3624" data-mp="2lfi5ektwoz6c">
        {sports.map(item => <li key={item} className="shrink-0" data-id="element-3625" data-mp="2gfvpu4qlv6ud">
            <FilterChip label={t(`category.${item}`)} active={sport === item} onClick={() => navigate(`/perfil/esportes/${item}`)} data-id="element-3626" data-mp="2geltpl3bc8qd" />
          </li>)}
      </ul>

      <Card className="mt-2 p-2" data-id="element-3627" data-mp="22p0g6q8a8lpq">
        <SectionTitle data-id="element-3628" data-mp="22oqmark49uer">{t('metrics.units')}</SectionTitle>
        <ul className="flex gap-1" data-id="element-3629" data-mp="22n7610ygnjcz">
          {(['metric', 'imperial'] as const).map(system => <li key={system} data-id="element-3630" data-mp="1xnkseqeq013n">
              <FilterChip label={t(`metrics.units.${system}`)} active={metrics.unitSystem === system} onClick={() => metrics.setUnitSystem(system)} data-id="element-3631" data-mp="1srchxqbgww2t" />
            </li>)}
        </ul>
      </Card>

      <Card className="mt-2 px-2" data-id="element-3632" data-mp="1jsih1nr3tjjg">
        <ul data-id="element-3633" data-mp="1a2ahdddez95z">
          {list.map(metric => <MetricRow key={metric.id} label={tl(metric.label)} kind={metric.kind} value={metric.value} hint={metric.value === 0 ? t('metrics.noRecord') : undefined} onOpen={metric.chart ? () => navigate(`/perfil/grafico/${encodeURIComponent(metric.id)}`) : undefined} data-id="element-3634" data-mp="1a4mwzjvp97fv" />)}
        </ul>
      </Card>

      {sport === 'strength' && <section className="mt-3" data-id="element-3635" data-mp="1xtxqcgapzzjz">
          <SectionTitle data-id="element-3636" data-mp="1j3qe4ibb3crq">{t('metrics.milestones')}</SectionTitle>
          <ul className="rounded-card border border-sand-line bg-white/70 px-2" data-id="element-3637" data-mp="1j1e0uightql0">
            {strengthMilestones.map(milestone => <li key={milestone.id} className="flex items-center gap-2 border-b border-sand-line py-2 last:border-b-0" data-id="element-3638" data-mp="2brmatn0vl4oi">
                <span className={`grid h-8 w-8 shrink-0 place-items-center rounded-pill ${milestone.reached ? 'bg-gold text-deep' : 'bg-sand-deep text-muted'}`} data-id="element-3639" data-mp="53ncny0sfu2c">
                  {milestone.reached ? <CheckIcon size={15} strokeWidth={3} data-id="element-3640" data-mp="9tu19xvavekl" /> : <CircleDashedIcon size={15} data-id="element-3641" data-mp="3i9vti1a0ppb9" />}
                </span>
                <span className="min-w-0 flex-1" data-id="element-3642" data-mp="3db2f86mwpua1">
                  <span className="block text-[13px] font-medium text-deep" data-id="element-3643" data-mp="3dcdryvybycda">
                    {tl(milestone.label)}
                  </span>
                  <span className="bee-num mt-[2px] block text-[11px] text-muted" data-id="element-3644" data-mp="3mbqsv08e1sme">
                    {tl(milestone.detail)}
                  </span>
                </span>
              </li>)}
          </ul>
        </section>}

      <p className="mt-2 px-1 text-[11px] leading-snug text-muted" data-id="element-3645" data-mp="11ki0339i47v3">
        {t('metrics.sports.note')}
      </p>
    </div>;
}